import { Content } from '.generated/Feature.CW.model';
import { Field, ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';
import { withStandardComponentWrapper } from 'helpers/HOC';
import ComponentWrapper from 'helpers/SitecoreWrappers/ComponentWrapper/ComponentWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import ThemeIconWrapper from 'helpers/ThemeIconWrappers/ThemeIconWrapper';
import useIsEditing from 'lib/hooks/useIsEditing';
import React from 'react';

type InPageBannerProps = Content.InPageBanner_Component & {
  isSidenavPart?: boolean;
  fields?: {
    icon?: {
      fields?: {
        Value?: Field<string>;
        Icon?: ImageField;
      };
    };
  };
};

const InPageBanner = (props: InPageBannerProps) => {
  const isEditing = useIsEditing();
  if (!isEditing && (!props?.fields?.bodyText?.value || props?.fields?.bodyText?.value === '')) {
    return <></>;
  }

  return (
    <div className="component-wrapper">
      <ComponentWrapper
        params={props?.params}
        isSidenavPart={props?.isSidenavPart}
        disableThemeInsideSideNav={true}
        className={!props?.isSidenavPart ? '!py-[30px]' : ''}
      >
        <div className="inpage-banner-wrapper px-10 lg:px-20 max-w-screen-xxl mx-auto print:bg-transparent print:text-black">
          <div className="bg-theme-bg p-12 rounded-md border border-theme-card-border-color flex flex-col md:flex-row gap-10 md:items-center shadow-default print-black-border">
            {/* todo start: Need developement  */}
            {((props?.fields?.icon?.fields?.Icon && props?.fields?.icon?.fields?.Value) ||
              isEditing) && (
              <div className="min-w-[80px] w-[80px] h-[80px] rounded-full bg-white flex justify-center items-center">
                <ThemeIconWrapper
                  classNames="!h-[41px] !w-[41px] text-theme-card-icon-color"
                  fields={props?.fields?.icon?.fields ?? {}}
                />
              </div>
            )}
            {/* todo End: Need developement  */}
            <div className="flex-grow">
              {(props?.fields?.heading?.value !== '' || isEditing) && (
                <h4
                  className={`font-bold mb-4 text-20 md:text-22 font-centuryGothic ${props?.params?.Theme == 'blue' ? 'text-white' : 'text-gray-900'}`}
                >
                  <PlainTextWrapper field={props?.fields?.heading} />
                </h4>
              )}

              <RichTextWrapper
                field={props?.fields?.bodyText}
                className={classNames(
                  props?.params?.Theme == 'blue' ? 'text-white [&_a]:!text-white' : 'text-gray-900'
                )}
              />
            </div>
            {((props?.fields?.ctaButton && props?.fields?.ctaButton?.value?.href !== '') ||
              isEditing) && (
              <div className="cta">
                <LinkWrapper
                  field={props?.fields?.ctaButton}
                  ctaVariant="secondary"
                  className="whitespace-nowrap print-black-border"
                />
              </div>
            )}
          </div>
        </div>
      </ComponentWrapper>
    </div>
  );
};

export const Default = withStandardComponentWrapper(InPageBanner);
